import to from 'await-to-js';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getMessaging, getToken, Messaging } from 'firebase/messaging';
interface FirebasAdapterConfigParameters {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
  vapID: string;
}

class FirebaseAdapter {
  config: FirebasAdapterConfigParameters = {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
    vapID: '',
  };

  serviceWorker: ServiceWorker | null = null;
  swReg: ServiceWorkerRegistration | null = null;
  pushManagerSubscription: PushSubscription | null = null;
  FirebaseAPP: FirebaseApp | null = null;
  FirebaseMessaging: Messaging | null = null;
  FirebaseToken: string | null = null;
  isDebuggerActive: Boolean = false;

  constructor({
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
    vapID,
  }: FirebasAdapterConfigParameters) {
    this.config = {
      apiKey,
      authDomain,
      databaseURL,
      projectId,
      storageBucket,
      messagingSenderId,
      appId,
      measurementId,
      vapID,
    };
  }

  DEBUGGER_MESSAGE(...args: any[]) {
    if (this.isDebuggerActive) {
      console.info.apply(null, ['[FB_DEBUGGER] -------->', ...args]);
    }
  }

  activateDebugger() {
    this.isDebuggerActive = true;
  }

  disableDebugger() {
    this.isDebuggerActive = false;
  }

  async installServiceWorker() {
    this.DEBUGGER_MESSAGE('WAITING FIREBASE-SW REGISTRATION');
    try {
      this.swReg = await window.navigator.serviceWorker.register('/firebase-messaging-sw.js');
    } catch (e) {
      this.DEBUGGER_MESSAGE('FIREBASE-SW REGISTRATION FAILED', e);
      throw new Error('FIREBASE-SW REGISTRATION FAILED');
    }
    this.serviceWorker = this.swReg.installing || this.swReg.waiting || this.swReg.active;
    return new Promise((resolve) => {
      if (this.serviceWorker?.state === 'activated') {
        this.DEBUGGER_MESSAGE('FIREBASE-SW INITALIZED', this.swReg);
        resolve(true);
      } else {
        this.serviceWorker?.addEventListener('statechange', (e: any) => {
          if (e?.target?.state === 'activated') {
            this.DEBUGGER_MESSAGE('FIREBASE-SW INITALIZED', this.swReg);
            resolve(true);
          }
        });
      }
    });
  }

  async subscribeToPushManager() {
    if (!this.swReg) {
      throw new Error('ServiceWorker Registration not exists');
    }

    const [err, subscription] = await to(
      this.swReg.pushManager?.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.config.vapID,
      })
    );

    if (err) {
      this.DEBUGGER_MESSAGE('FCM Subscription failed');
      throw new Error('FCM Subscription failed');
    }

    if (subscription) {
      this.pushManagerSubscription = subscription;
    }
  }

  initializeFireBaseApp() {
    this.FirebaseAPP = initializeApp(this.config);
    this.FirebaseMessaging = getMessaging(this.FirebaseAPP);
  }

  async getFirebaseToken() {
    if (!this.FirebaseMessaging) {
      throw new Error('Firebase Messaging not active');
    }

    if (!this.swReg) {
      throw new Error('ServiceWorker Registration not exists');
    }

    const [err, token] = await to(
      getToken(this.FirebaseMessaging, {
        vapidKey: this.config.vapID,
      })
    );

    if (err) {
      this.DEBUGGER_MESSAGE('Firebase Token Retrieve failed : ' + err);
      throw new Error(`Token couldn't retrieved from Firebase`);
    }

    this.FirebaseToken = token;

    return token;
  }
}

export default FirebaseAdapter;
